import { graphql, useStaticQuery } from "gatsby";

const BlogCategories = () => {
    const resourceData = useStaticQuery(graphql`
        query allBlogCategoryData {
            allCategoryData: allContentfulBlog(
                sort: [{ dateTime: DESC }, { updatedAt: DESC }]
                filter: { node_locale: { eq: "en" } }
            ) {
                By_Topics: group(field: { topic: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                        }
                    }
                }
                By_Trends: group(field: { trend: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                        }
                    }
                }
                By_Industries: group(field: { industry: { title: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                        }
                    }
                }
                By_Authors: group(field: { author: { id: SELECT } }) {
                    fieldValue
                    edges {
                        node {
                            id
                        }
                    }
                }
            }
            authors: allContentfulAuthor {
                nodes {
                    id
                    firstName
                    lastName
                }
            }
        }
    `);

    return resourceData;
};

export default BlogCategories;
